var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_6608",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_6608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8181 6.6964H10.6639V3.08954C10.6639 2.7 10.3465 2.36816 9.94256 2.36816H7.05706C6.65309 2.36816 6.33569 2.7 6.33569 3.08954V6.6964H5.18151C4.5467 6.6964 4.21487 7.47549 4.66212 7.93717L7.98042 11.2555C8.26897 11.544 8.71624 11.544 8.99036 11.2555L12.3087 7.93717C12.7559 7.47549 12.4529 6.6964 11.8037 6.6964H11.8181ZM3.4502 13.9101C3.4502 14.2997 3.7676 14.6315 4.17157 14.6315H12.8281C13.2176 14.6315 13.5494 14.2997 13.5494 13.9101C13.5494 13.5206 13.2176 13.1888 12.8281 13.1888H4.17157C3.7676 13.1888 3.4502 13.5206 3.4502 13.9101Z",
    fill: "#000",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.6be4f044c7990325aae61f49a708f45c.svg";
export { ForwardRef as ReactComponent };